import { styled } from '@mui/material';

export const StyledGradeBookWeekDayLessonsList = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
	width: '100%',
	padding: '8px',
});
